type ValidType = {
  reg: RegExp;
  mes: string;
  key: string;
};

export const VALID_REG: { [key: string]: ValidType } = {
  required: {
    key: "required",
    reg: /^\d{10}$/,
    mes: "Field is required",
  },
  email: {
    reg: /\S+@\S+\.\S+/,
    mes: "Invalid type email",
    key: "email",
  },
  website: {
    reg: /^(ftp|http|https):\/\/[^ "]+$/,
    mes: "Invalid website",
    key: "website",
  },
  phone: {
    key: "phone",
    reg: /^\d{10}$/,
    mes: "Invalid phone number",
  },
  street: {
    key: "street",
    reg: /^[a-zA-Z0-9\s]/,
    mes: "Invalid street",
  },
  postcode: {
    key: "postcode",
    reg: /^[a-zA-Z0-9\s]/,
    mes: "Invalid postcode",
  },
  salutation: {
    key: "salutation",
    reg: /^[a-zA-Z0-9\s]/,
    mes: "Invalid salutation",
  },
  estimatedRevenue: {
    key: "estimatedRevenue",
    reg: /^[a-zA-Z0-9\s]/,
    mes: "Invalid Estimated revenue",
  },
  estimatedProbability: {
    key: "estimatedProbability",
    reg: /^[a-zA-Z0-9\s]/,
    mes: "Invalid Estimated probability",
  },
};
